import moment from 'moment-timezone'
import fp from 'lodash/fp'

import { Map } from 'immutable'
import errors from '../../config/errors'

import {
  SCHEDULE_ERROR,
  SCHEDULE_SUCCESS,
  SCHEDULE_LOADING,
  SET_DATES,
  APPEND_TIMESLOT,
  SELECT_TIMESLOT,
  RESET_TIMESLOTS,
  INCREASE_MONTH,
  CANCEL_FROM_UPCOMING_VISIT,
  DECREASE_MONTH
} from './action-types'

const initialState = Map({
  data: null,
  error: errors.basic,
  month: moment().format(),
  selectedTimeslot: null,
  dates: [],
  timeslots: [],
  isLoading: null,
  isSuccess: null,
  hasError: null,
  isCancelFromUpcomingVisit: false
})

const scheduleReducer = (state = initialState, action) => {
  switch (action.type) {
    case SCHEDULE_SUCCESS:
      return state
        .set('isLoading', false)
        .set('isSuccess', true)
        .set('hasError', false)
        .set('data', action.payload)
        .set('error', errors.basic)
    case SCHEDULE_ERROR:
      return state
        .set('isLoading', false)
        .set('isSuccess', false)
        .set('hasError', true)
        .set('error', action.error)
    case SCHEDULE_LOADING:
      return state
        .set('isLoading', true)
        .set('isSuccess', false)
        .set('hasError', false)
        .set('error', errors.basic)
    case SET_DATES:
      return state.set('dates', action.payload)
    case SELECT_TIMESLOT:
      return state.set('selectedTimeslot', action.payload)
    case CANCEL_FROM_UPCOMING_VISIT:
      return state.set('isCancelFromUpcomingVisit', action.payload)
    case APPEND_TIMESLOT:
      return state.set(
        'timeslots',
        fp.union(action.payload, state.get('timeslots'))
      )
    case RESET_TIMESLOTS:
      return state.set('timeslots', [])
    case INCREASE_MONTH:
      return state.set(
        'month',
        moment(state.get('month'))
          .add(1, 'M')
          .format()
      )
    case DECREASE_MONTH:
      return state.set(
        'month',
        moment(state.get('month'))
          .subtract(1, 'M')
          .format()
      )
    default:
      return state
  }
}

export default scheduleReducer
